export default __webpack_public_path__ + "static/media/maisons_laffitte10.3c1a1f2f.jpg";